import axios from 'axios';

axios.defaults.withCredentials = true;

export async function sendRequest(mess, key, id, thread){

    const axiosConfig = {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/sendRequest`, {
                                              message: mess,
                                              key:key,
                                              id:id,
                                              thread:thread
                                          }, axiosConfig
        );
        if (response.data.success) {
            localStorage.setItem('thread',response.data.thread);
            return(response.data.mess)
        } else {
            return(response.data.mess)
        }
    } catch (error) {
        return(error.errorMess);
    }
}